/**
 * Product image URL resolution.
 *
 * POSHUB returns two image fields on a product, and they differ in shape:
 *
 *   "image":      "/images/upload_products/B26_746_1779353529.jpeg"     // RELATIVE
 *   "image_webp": "https://nl130021.poshub.io/.../B26_746_..._web.webp" // ABSOLUTE
 *
 * The WebP derivative is ~82% smaller, so it is preferred whenever present.
 * It is null for products that have no derivative yet, in which case the
 * original `image` is used exactly as before.
 *
 * Because the two fields differ in relative/absolute-ness, the resolved value
 * is only prefixed with the API host when it is not already absolute.
 */

function isNonEmptyString(value) {
  return typeof value === 'string' && value.trim() !== '';
}

/**
 * Pick the best available source field for a product, preferring WebP.
 * Returns '' when the product has no usable image at all.
 */
export function getProductImageSource(product) {
  if (!product) {
    return '';
  }

  if (isNonEmptyString(product.image_webp)) {
    return product.image_webp;
  }

  return isNonEmptyString(product.image) ? product.image : '';
}

/**
 * Resolve a product's image to a URL usable as an <img> src.
 * Absolute URLs are returned untouched; relative ones get the API host.
 */
export function getProductImageUrl(product, apiServer) {
  const source = getProductImageSource(product);

  if (!source) {
    return '';
  }

  if (source.startsWith('http')) {
    return source;
  }

  const host = isNonEmptyString(apiServer)
    ? apiServer
    : process.env.VUE_APP_ROOT_API_SERVER || '';

  return host + source;
}

export default getProductImageUrl;
